import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import s from './DeveloperPageContainer.scss';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { composer } from '../../component-decorators/composer';
import { CenteredLoader } from '../centered-loader';
import { useConfigContext } from '../../config-context';
import { FluidContainer } from '../FluidContainer';
import { SolutionGridWrapper } from '../solution-grid-wrapper/solution-grid-wrapper';
import { CategoriesCarousel } from '../home/partials/CategoriesCarousel';
import { fetchDeveloperPageData } from './fetchDeveloperPageData';
import { categoriesCarouselProps } from './categoriesCarouselProps';
import { DeveloperPageTopSection } from './developer-page-top-section';
var DeveloperPage = /** @class */ (function (_super) {
    __extends(DeveloperPage, _super);
    function DeveloperPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeveloperPage.prototype.getIconUrl = function () {
        var _a, _b, _c, _d, _e, _f;
        return (_f = (_e = (_d = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.companyInfo) === null || _b === void 0 ? void 0 : _b.assetsMap) === null || _c === void 0 ? void 0 : _c.companyIcon) === null || _d === void 0 ? void 0 : _d.assets) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.url;
    };
    DeveloperPage.prototype.render = function () {
        var _a;
        var _b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.companyInfo, companyBase = _b.companyBase, averageRating = _b.averageRating, webSolutions = _b.webSolutions;
        console.log("marketplace-component/src/components/developer-page-container/developer-page-container.tsx file - line 37 - " + Date.now());
        return (React.createElement(React.Fragment, null,
            React.createElement(FluidContainer, { className: s.conatiner },
                React.createElement(DeveloperPageTopSection, { icon: this.getIconUrl(), name: companyBase === null || companyBase === void 0 ? void 0 : companyBase.name, t: this.props.t, appsCount: webSolutions.length, averageRating: averageRating, marketplaceStore: this.props.marketplaceStore }),
                React.createElement(SolutionGridWrapper, { solutions: webSolutions.map(function (solution, appIndex) {
                        return __assign({ appIndex: appIndex }, solution);
                    }), referralSectionName: "developer-page" })),
            React.createElement("div", { className: s.carouselContainer },
                React.createElement(CategoriesCarousel, __assign({ className: s.carousel }, categoriesCarouselProps(this.props.categories, this.props.t))))));
    };
    DeveloperPage = __decorate([
        withMarketplaceStore
    ], DeveloperPage);
    return DeveloperPage;
}(React.Component));
export var DeveloperPageContainer = composer()
    .withTranslation()
    .compose(function (props) {
    // tslint:disable-next-line: react-hooks-nesting
    var _a = useConfigContext(), locale = _a.locale, rpcClient = _a.rpcClient;
    console.log("marketplace-component/src/components/developer-page-container/developer-page-container.tsx file - line 73 - " + Date.now());
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: fetchDeveloperPageData(props.slug, locale, rpcClient), fetchMemoizationId: "developer-" + props.slug + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData;
        return (React.createElement(DeveloperPage, { slug: props.slug, companyInfo: fetchData.company, categories: fetchData.categories, t: props.t }));
    }));
});
//# sourceMappingURL=developer-page-container.js.map